import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";
import {useMemo, useState} from "react";
import {AgGridReact} from "ag-grid-react";
import AgGridUtils from "../../../../../../utils/aggrid-utils.js";
import PrintableTableAgGrid from "../../../../../../components/printable-table/printable-table-ag-grid.jsx";

export default function Displacements({ title, data }) {
    const [gridApi, setGridApi] = useState(null);
    const displacements = data?.dispatch?.displacements ?? [];

    const formatAddress = (row) => {
        const street = row?.displacement_street?.trim();
        const neighborhood = row?.displacement_neighborhood?.trim();
        const number = row?.displacement_number?.trim();

        return [street, neighborhood, number]
            .filter(Boolean)
            .join(", ");
    }

    const columnDefs = useMemo(() => ([
        { headerName: "D/H inicial", field: "displacement_start", flex: 1 },
        { headerName: "D/H final", field: "displacement_end", flex: 1 },
        { headerName: "Local pré-cadastrado", field: "displacement_destiny", flex: 2 },
        { headerName: "Endereço", field: "displacement_address", valueGetter: (params) => formatAddress(params.data), flex: 3 },
    ]), []);

    return (
        <div className="space-y-4 px-5">
            <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f]">
                {title}
            </h2>
            <div className="w-full print:hidden">
                <AgGridReact
                    rowData={displacements ?? []}
                    columnDefs={columnDefs}
                    defaultColDef={{ resizable: false }}
                    animateRows={false}
                    suppressCellFocus={true}
                    gridOptions={{ localeText: AgGridUtils.localization() }}
                    theme={AgGridUtils.generalTheme({ headerTextColor: "#676a6c" })}
                    domLayout="autoHeight"
                    onGridReady={(params) => setGridApi(params.api)}
                    suppressRowHoverHighlight={true}
                />
            </div>
            <div className="hidden print:block rounded-[8px] overflow-hidden border border-[#e0e1e3]">
                <PrintableTableAgGrid
                    formatters={{
                        displacement_address: formatAddress
                    }}
                    gridApi={gridApi}
                    className="!border-0 w-full -mx-px"
                    thClassName="first:!border-l-0 last:!border-r-0 text-[#676a6c]"
                    tdClassName="first:!border-l-0 last:!border-r-0"
                />
            </div>
        </div>
    )
}